import { AUTHENTICATION_STATUS } from '../../services/authentication/authentication-utilities.service';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  standalone: false,
})
export class PageNotFoundComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.authenticationService.authState$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((authState) => {
        if (authState.status === AUTHENTICATION_STATUS.UNAUTHENTICATED) {
          this.router.navigate(['/public']);
        }
      });
  }
}
